// removed by extract-text-webpack-plugin
module.exports = {"base":"Gold_base--2dgSV","base__isNotEnough":"Gold_base__isNotEnough--mGZvP","baseIsNotEnough":"Gold_base__isNotEnough--mGZvP","base__size-small":"Gold_base__size-small--1t8P2","baseSizeSmall":"Gold_base__size-small--1t8P2","base__size-large":"Gold_base__size-large--37-vz","baseSizeLarge":"Gold_base__size-large--37-vz","base__isDisabled":"Gold_base__isDisabled--194Qm","baseIsDisabled":"Gold_base__isDisabled--194Qm","base__before":"Gold_base__before--gqykS","baseBefore":"Gold_base__before--gqykS","base__after":"Gold_base__after--6McxX","baseAfter":"Gold_base__after--6McxX"};


//////////////////
// WEBPACK FOOTER
// ../node_modules/react-wot-bootstrap/lib/components/Gold/Gold.css
// module id = 1770
// module chunks = 16